/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import  React, { PureComponent, createRef } from 'react';
import { Grid, withStyles } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import {
    object, func, string, bool,
} from 'prop-types';
import Button from '@material-ui/core/Button';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

const styles = (theme) => ({
    sortAndFilterContainer: {
        position: 'relative',
        marginLeft: 'auto',
        width: '100%',
        [theme.breakpoints.up('md')]: {
            minWidth: 105,
        },
    },
    sortFilterContainerFood: {
        [theme.breakpoints.down(599)]: {
            width: '100%',
            margin: '0',
        },
    },
    filterBtn: {
        display: 'inline-block',
        cursor: 'pointer',
        fontWeight: '700',
        fontSize: '14px',
        width: '138px',
        textAlign: 'center',
        '& svg': {
            marginLeft: '5px',
            fontSize: '1rem',
            verticalAlign: 'middle',
        },
    },
    filterBtnFood: {
        display: 'flex',
        alignItems: 'center',
        fontWeight: '600',
        fontStyle: 'normal',
        lineHeight: '16px',
        position: 'relative',
        justifyContent: 'center',
        alignContent: 'center',
        height: '40px',
        cursor: 'pointer',
        background: theme.palette.common?.white || '#ffffff',
        border: `1px solid ${theme.palette.upsellsTextColor || '#2F2F2F'}`,
        fontSize: '16px',
        boxSizing: 'border-box',
        [theme.breakpoints.down(599)]: {
            width: '100%',
            fontSize: '14px',
        },
        '& svg': {
            marginLeft: '10px',
        },
    },
    filterBtnFoodLeft: {
        paddingLeft: '5px',
        justifyContent: 'start',
    },
    buttonLabel: {
        textAlign: 'center',
        width: '100%',
    },
    filterContainerDialog: {
        position: 'absolute',
        right: 0,
        top: '38px',
        left: '-20px',
        zIndex: 3,
        maxWidth: '180px',
        width: '180px',
        padding: '10px',
        boxShadow: '0px 2px 3px -1px rgba(0,0,0,0.35)',
        background: theme.palette.colorPrimaryContrast,
    },
    filterContainerDialogFood: {
        position: 'absolute',
        right: 0,
        top: '45px',
        zIndex: 3,
        width: '188px',
        background: 'transparent',
        [theme.breakpoints.down(581)]: {
            width: '100%',
        },
        [theme.breakpoints.down(599)]: {
            width: '126px',
        },
    },
    filterContainerDialogFoodBox: {
        width: '100%',
        boxShadow: '0px 2px 3px -1px rgba(0,0,0,0.35)',
        background: theme.palette.colorPrimaryContrast,
        borderRadius: '0px',
    },
    collapsedContainer: {
        width: '100%',
    },
    filterTitle: {
        color: theme.palette.colorNeutral70,
        fontSize: '16px',
        fontWeight: 700,
        lineHeight: '20px',
        margin: '16px 0',
    },
    filterSearchBtn: {
        padding: '13px 25px',
        borderRadius: '0px',
        width: '100%',
        color: theme.palette.colorNeutral70,
        fontWeight: 700,
        textTransform: 'capitalize',
        fontSize: '14px',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&:focus': {
            background: theme.palette.cms?.primary || theme.palette.colorPrimary,
            color: theme.palette.colorPrimaryContrast,
        },
        '&:active': {
            background: theme.palette.cms?.primary || theme.palette.colorPrimary,
            color: theme.palette.colorPrimaryContrast,
        },
        [theme.breakpoints.down('sm')]: {
            padding: '8px 10px',
        },
    },
    textRight: {
        textAlign: 'right',
    },
    content: {
        padding: '15px 0px',
        fontSize: '14px',
        fontWeight: 700,
        color: theme.palette.colorNeutral70,
    },
    applyBtn: {
        color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        width: '100%',
        border: '2px solid',
        display: 'block',
        padding: '8px 0px',
        textAlign: 'center',
        textTransform: 'uppercase',
        fontSize: '14px',
        fontWeight: 700,
        cursor: 'pointer',
    },
    btnBackground: {
        background: theme.palette.common?.black || theme.palette.colorPrimary,
        color: theme.palette.colorPrimaryContrast,
    },
    applyButtonWrapper: {
        marginTop: '10px',
    },
    switch: {
        '& span': {
            '& span': {
                color: theme.palette.cms?.primary || theme.palette.colorPrimary,
            },
        },
    },
    options: {
        margin: '0',
        textDecoration: 'none',
        listStyle: 'none',
        textAlign: 'left',
        padding: '0',
        '& li': {
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '10px',
            height: '40px',
            fontStyle: 'normal',
            color: theme.palette.upsellsTextColor || '#2F2F2F',
            lineHeight: '16px',
            '&:hover': {
                background: theme.palette.highlightColor || '#F5F5F5',
            },
            [theme.breakpoints.down(581)]: {
                paddingLeft: '8px',
            },
            [theme.breakpoints.down(415)]: {
                paddingLeft: '5px',
                fontSize: '16px',
            },
            [theme.breakpoints.down(599)]: {
                fontSize: '14px',
            },
        },
        '& span': {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.down(581)]: {
                marginRight: '5px',
            },
        },
    },
    activeColor: {
        background: theme.palette.highlightColor || '#F5F5F5',
    },
    doneIcon: {
        fontSize: '20px',
    },
    filterFacetsV3: {
        width: '188px',
        '& span': {
            fontSize: '16px',
        },
    },
    filterSelectedLabelFood: {
        width: '188px',
        [theme.breakpoints.down(599)]: {
            width: '126px',
        },
        '& span': {
            fontSize: '1rem',
            [theme.breakpoints.down(599)]: {
                fontSize: '14px',
            },
        },
    },
    filterSelectedLabel: {
        lineHeight: '40px',
        '& span': {
            [theme.breakpoints.down(324)]: {
                fontSize: '15px',
            },
        },
    },
    filterFacetV3Dialog: {
        position: 'absolute',
        right: 0,
        top: '45px',
        zIndex: 5,
        [theme.breakpoints.down(581)]: {
            width: '100%',
            maxWidth: '100%',
        },
    },
    popUpFilterSlider: {
        position: 'static',
        maxWidth: '100%',
        width: '100%',
        '& $filterContainerDialogFoodBox': {
            boxShadow: 'none',
            background: 'inherit',
            '& ul': {
                padding: 0,
            },
        },
        '& $options': {
            borderLeft: '1px solid #eee',
            '& $activeColor': {
                background: theme.palette.common?.white || '#ffffff',
            },
            '& li': {
                fontFamily: 'Garamond, Times, serif',
                cursor: 'pointer',
                display: 'flex',
                fontSize: '14px',
                alignItems: 'center',
                paddingLeft: '10px',
                marginBottom: '15px',
                fontWeight: 'normal',
                height: 'auto',
                lineHeight: 'normal',
                '&:hover': {
                    background: theme.palette.common?.white || '#ffffff',
                },
            },
        },
    },
    popUpsortAndFilterContainer: {
        maxWidth: '100%',
        width: '100%',
        borderTop: '1px solid #cdcdcd',
        padding: '15px 0 35px',
        '& $filterBtnFood': {
            padding: 0,
            width: '100%',
            boxShadow: 'none',
            border: 'none',
            fontWeight: '400',
            borderRadius: '4px',
            justifyContent: 'center',
            '@media screen and (max-width: 480px)': {
                fontSize: '16px',
                minWidth: '85px',
                padding: '0 15px',
            },
            '@media screen and (max-width: 340px)': {
                fontSize: '16px',
            },
        },
        '& $filterBtnFlowers': {
            border: 'none',
            boxShadow: 'none',
            justifyContent: 'center',
            width: '100%',
            '@media screen and (max-width: 480px)': {
                fontSize: '16px',
                minWidth: '85px',
                padding: '0 15px',
            },
        },
    },
    popUpsortAndFilterContainerFloral: {
        padding: '0px',
        [theme.breakpoints.down(599)]: {
            width: '100%',
            margin: '0px 0px 0px 10px',
        },
    },
    popSliderTitle: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontFamily: 'Garamond, Times, serif',
        '& span': {
            fontSize: 20,
            [theme.breakpoints.down(481)]: {
                fontSize: 14,
            },
        },
    },
    popSliderPopular: {
        display: 'flex',
        alignItems: 'center',
    },
    activeLabelColorV3: {
        background: theme.palette.highlightColor || '#F5F5F5',
        letterSpacing: 'normal',
        fontSize: '15px',
        fontWeight: 400,
        [theme.breakpoints.down(581)]: {
            '& svg': {
                marginLeft: '0',
            },
        },
    },
    flowersActiveLabel: {
        background: theme.palette?.common?.white || '#ffffff',
    },
    filterBtnFlowers: {
        color: theme.palette?.black || '#000000',
        fontSize: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '40px',
        background: theme.palette?.common?.white || '#ffffff',
        border: `1px solid ${theme.palette?.upsellsTextColor || '#2F2F2F'}`,
        boxSizing: 'border-box',
        boxShadow: '0px 2px 3px rgb(0 0 0 / 35%)',
        [theme.breakpoints.down(599)]: {
            width: '100%',
            '& svg': {
                marginLeft: '5px',
            },
        },
    },
    sortByLabel: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        alignContent: 'center',
        marginRight: '10px',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: '700',
        fontSize: '16px',
        lineHeight: '20px',
        letterSpacing: '0.02em',
        color: theme.palette?.upsellsTextColor || '#2F2F2F',
    },
    containerFilterFood: {
        justifyContent: 'flex-end',
    },
});

class DesktopFilterDialogV3 extends PureComponent {
    constructor(props) {
        super(props);
        const { presentationFamily } = props;
        this.state = {
            toggleFilter: false,
            sellingBtn: true,
            atozBtn: false,
            ztoaBtn: false,
            highToLowBtn: false,
            lowToHighBtn: false,
            localFlorist: true,
            giftBox: true,
            buttonLabel: presentationFamily === 'food' ? '' : 'Best Sellers',
        };
        this.containerRef = createRef();
    }

    componentDidMount() {
        if (typeof document !== 'undefined') {
            document.addEventListener('mousedown', this.handleClickOutside);
        }
    }

    componentWillUnmount() {
        if (typeof document !== 'undefined') {
            document.removeEventListener('mousedown', this.handleClickOutside);
        }
    }

    handleClickOutside = (event) => {
        if (this.containerRef && event?.target && this.containerRef?.current && !this.containerRef.current.contains(event.target)) {
            this.setState({
                toggleFilter: false,
            });
        }
    }

    toggleFilter = () => {
        const { toggleFilter } = this.state;
        this.setState({
            toggleFilter: !toggleFilter,
        });
    };

    applyFilter =() => {
        const { setFilterOptions } = this.props;
        const {
            toggleFilter, giftBox, highToLowBtn, sellingBtn, localFlorist, lowToHighBtn, atozBtn, ztoaBtn,
        } = this.state;
        this.setState({
            sellingBtn,
            highToLowBtn,
            lowToHighBtn,
            localFlorist,
            giftBox,
            atozBtn,
            ztoaBtn,
            toggleFilter: !toggleFilter,
        });
        setFilterOptions({
            toggleFilter, giftBox, highToLowBtn, sellingBtn, localFlorist, lowToHighBtn, atozBtn, ztoaBtn,
        });
    }

    handleChangeLocalFlorist =   () => {
        const { localFlorist } = this.state;
        this.setState({
            localFlorist: !localFlorist,
        });
    };

    handleChangeGiftBox =   () => {
        const { giftBox } = this.state;
        this.setState({
            giftBox: !giftBox,
        });
    };

    setFilterData = (filter) => {
        switch (filter) {
            case 'sellingBtn':
                return this.setState({
                    sellingBtn: true,
                    highToLowBtn: false,
                    lowToHighBtn: false,
                    ztoaBtn: false,
                    atozBtn: false,
                    buttonLabel: 'Best Selling',
                }, () => this.applyFilter());
            case 'highToLowBtn':
                return this.setState({
                    sellingBtn: false,
                    highToLowBtn: true,
                    lowToHighBtn: false,
                    ztoaBtn: false,
                    atozBtn: false,
                    buttonLabel: 'Price: High - Low',
                }, () => this.applyFilter());
            case 'lowToHighBtn':
                return this.setState({
                    sellingBtn: false,
                    highToLowBtn: false,
                    lowToHighBtn: true,
                    ztoaBtn: false,
                    atozBtn: false,
                    buttonLabel: 'Price: Low - High',
                }, () => this.applyFilter());
            case 'atoz':
                return this.setState({
                    sellingBtn: false,
                    highToLowBtn: false,
                    lowToHighBtn: false,
                    ztoaBtn: false,
                    atozBtn: true,
                    buttonLabel: 'Name: A to Z',
                }, () => this.applyFilter());
            case 'ztoa':
                return this.setState({
                    sellingBtn: false,
                    highToLowBtn: false,
                    lowToHighBtn: false,
                    ztoaBtn: true,
                    atozBtn: false,
                    buttonLabel: 'Name: Z to A',
                }, () => this.applyFilter());
            default:
                return null;
        }
    }

    renderSortOptionsFloral = () => {
        const { classes } = this.props;
        const {
            sellingBtn, highToLowBtn, lowToHighBtn,
        } = this.state;
        return (
            <Grid container className={classes.filterContainerDialog}>
                <Grid item xs={12}>
                    <div>
                        <Button onClick={() => this.setFilterData('sellingBtn')} className={sellingBtn ? `${classes.filterSearchBtn} ${classes.btnBackground}` : classes.filterSearchBtn}>Best Sellers</Button>
                        {/* <Button onClick={() => this.setFilterData('atoz')} className={atozBtn ? `${classes.filterSearchBtn} ${classes.btnBackground}` : classes.filterSearchBtn}>Name: A to Z</Button>
                        <Button onClick={() => this.setFilterData('ztoa')} className={ztoaBtn ? `${classes.filterSearchBtn} ${classes.btnBackground}` : classes.filterSearchBtn}>Name: Z to A</Button> */}
                        <Button onClick={() => this.setFilterData('lowToHighBtn')} className={lowToHighBtn ? `${classes.filterSearchBtn} ${classes.btnBackground}` : classes.filterSearchBtn}>Price: Low to High</Button>
                        <Button onClick={() => this.setFilterData('highToLowBtn')} className={highToLowBtn ? `${classes.filterSearchBtn} ${classes.btnBackground}` : classes.filterSearchBtn}>Price: High to Low </Button>
                    </div>
                </Grid>
            </Grid>
        );
    }

    renderSortOptionsFood = () => {
        const {
            classes, setFilterOptions, isDesktopFacetsV3, isPopFilterSlider,
        } = this.props;
        const {
            toggleFilter, giftBox, highToLowBtn, sellingBtn, localFlorist, lowToHighBtn, buttonLabel,
        } = this.state;
        return (
            <Grid container className={`${isDesktopFacetsV3 ? classes.filterFacetV3Dialog : classes.filterContainerDialogFood} ${isPopFilterSlider ? classes.popUpFilterSlider : ''}`}>
                <Collapse in={toggleFilter} timeout={300} className={classes.collapsedContainer}>
                    <Paper className={classes.filterContainerDialogFoodBox} elevation={0}>
                        <Grid item xs={12}>
                            <ul className={classes.options}>
                                <li className={`${(buttonLabel && sellingBtn) ? classes.activeColor : ''}`}>
                                    <span
                                        role="presentation"
                                        onClick={() => {
                                            this.setState({
                                                sellingBtn: true,
                                                highToLowBtn: false,
                                                lowToHighBtn: false,
                                                buttonLabel: 'Best Sellers',
                                                localFlorist,
                                                giftBox,
                                                toggleFilter: !toggleFilter,
                                            });
                                            setFilterOptions({
                                                toggleFilter,
                                                giftBox,
                                                sellingBtn: true,
                                                highToLowBtn: false,
                                                lowToHighBtn: false,
                                                localFlorist,
                                            });
                                        }}
                                        className={classes.optionLink}
                                    >Best Sellers
                                    </span>
                                </li>
                                <li className={`${(buttonLabel && lowToHighBtn) ? classes.activeColor : ''}`}>
                                    <span
                                        role="presentation"
                                        onClick={() => {
                                            this.setState({
                                                sellingBtn: false,
                                                highToLowBtn: false,
                                                lowToHighBtn: true,
                                                buttonLabel: 'Price: Low to High',
                                                localFlorist,
                                                giftBox,
                                                toggleFilter: !toggleFilter,
                                            });
                                            setFilterOptions({
                                                toggleFilter,
                                                giftBox,
                                                sellingBtn: false,
                                                highToLowBtn: false,
                                                lowToHighBtn: true,
                                                localFlorist,
                                            });
                                        }}
                                        className={classes.optionLink}
                                    >Price: Low to High
                                    </span>
                                </li>
                                <li className={`${(buttonLabel && highToLowBtn) ? classes.activeColor : ''}`}>
                                    <span
                                        role="presentation"
                                        onClick={() => {
                                            this.setState({
                                                sellingBtn: false,
                                                highToLowBtn: true,
                                                lowToHighBtn: false,
                                                buttonLabel: 'Price: High to Low',
                                                localFlorist,
                                                giftBox,
                                                toggleFilter: !toggleFilter,
                                            });
                                            setFilterOptions({
                                                toggleFilter,
                                                giftBox,
                                                sellingBtn: false,
                                                highToLowBtn: true,
                                                lowToHighBtn: false,
                                                localFlorist,
                                            });
                                        }}
                                        className={classes.optionLink}
                                    >Price: High to Low
                                    </span>
                                </li>
                            </ul>
                        </Grid>
                    </Paper>
                </Collapse>
            </Grid>
        );
    }

    renderSortOptions =() => {
        const {
            presentationFamily,
            isDesktopFacetsV3,
        } = this.props;
        const {
            toggleFilter,
        } = this.state;

        if (presentationFamily === 'food' || (presentationFamily === 'flower' && isDesktopFacetsV3)) {
            return  this.renderSortOptionsFood();
        }
        return toggleFilter ?  this.renderSortOptionsFloral() : <></>;
    }

    render() {
        const {
            classes, presentationFamily, isDesktopFacetsV3, isPopFilterSlider,
        } = this.props;
        const {
            buttonLabel,
        } = this.state;

        const isFood = presentationFamily === 'food';
        const selectedLabelStyle = buttonLabel ? `${classes.activeLabelColorV3} ${classes.flowersActiveLabel}` : '';

        const expandButton = (
            <svg width="17" height="15" viewBox="0 0 17 15" fill="none">
                <path d="M3.54348 1V13.5M3.54348 13.5L0.5 11M3.54348 13.5L6.58696 11" stroke="#2F2F2F" strokeLinecap="round" />
                <path d="M12.6739 13.5V1M12.6739 1L9.63043 3.5M12.6739 1L15.7174 3.5" stroke="#2F2F2F" strokeLinecap="round" />
            </svg>
        );
        const renderLabelFood = () => {
            if (isPopFilterSlider) {
                return (
                    <div className={classes.popSliderTitle}>
                        <span>Sort By</span>
                        <span className={classes.popSliderPopular}>{buttonLabel || 'Best Sellers'}{expandButton}</span>
                    </div>
                );
            }
            if (isFood && !isPopFilterSlider) {
                return <>{`${buttonLabel ? `${buttonLabel}` : 'Sort By'}`} {!buttonLabel ? expandButton : ''}</>;
            }

            return (<>sort &amp; filter</>);
        };

        const renderLabel = () => (
            <>
                <span className={classes.buttonLabel}>{buttonLabel}</span>
                { this.state.toggleFilter ? <ExpandLessIcon /> : <ExpandMoreIcon /> }
            </>
        );

        return (
            <div
                ref={this.containerRef}
                className={`${classes.sortAndFilterContainer} ${isPopFilterSlider ? classes.popUpsortAndFilterContainer : ''} ${classes.sortFilterContainerFood}`}
            >
                <Grid container className={isFood ? classes.containerFilterFood : ''}>
                    {isFood && buttonLabel && (<div className={classes.sortByLabel}>Sort by</div>)}
                    <div className={presentationFamily === 'food' && isDesktopFacetsV3 ? classes.filterFacetsV3 : `${isFood ? classes.filterSelectedLabelFood : classes.filterSelectedLabel}`}>
                        <span
                            role="presentation"
                            aria-hidden="true"
                            onClick={() => this.toggleFilter()}
                            className={isFood
                                ? `${classes.filterBtnFood} ${buttonLabel ? `${classes.activeLabelColorV3} ${classes.filterBtnFoodLeft}` : ''}`
                                : `${isDesktopFacetsV3 ? `${classes.filterBtn} ${classes.filterBtnFlowers} ${selectedLabelStyle}` : classes.filterBtn}`}
                        >
                            {isFood ? renderLabelFood() : renderLabel()}
                        </span>
                    </div>
                </Grid>

                {this.renderSortOptions()}
            </div>
        );
    }
}

DesktopFilterDialogV3.propTypes = {
    classes: object.isRequired,
    setFilterOptions: func.isRequired,
    presentationFamily: string.isRequired,
    isDesktopFacetsV3: bool,
    isPopFilterSlider: bool,
};
DesktopFilterDialogV3.defaultProps = {
    isPopFilterSlider: false,
    isDesktopFacetsV3: false,
};

export default withStyles(styles)(DesktopFilterDialogV3);
